import httpApi from '@/utils/http-api'
import { api } from '@/config'

export default {
  getAllBanners: () => {
    return httpApi.getDataViaApi({
      url: api.banner.getAllBanners
    })
  }
}
